exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.json-nested-viewer[data-v-f29fde5c] {\r\n  width: 100%;\r\n  max-height: 70vh;\r\n  overflow: auto;\r\n  padding: 4px 0;\n}\n.json-view-dialog-body[data-v-f29fde5c] {\r\n  min-width: 0;\n}\n.json-nested-empty[data-v-f29fde5c] {\r\n  color: #909399;\r\n  text-align: center;\r\n  padding: 24px 0;\r\n  font-size: 13px;\n}\r\n", ""]);

